import {Breakpoint} from '@mui/material';
import React, {ReactNode, useState} from 'react';
import CustomDialog from './CustomDialog';
import {DialogContextProvider} from 'components/dialog/DialogContext';
import FilePicker, {FilePickerProps} from 'components/common/FilePicker';
import {toast} from 'react-toastify';

const FilePickerDialog = (props: FilePickerDialogProps) => {
  const {children, dialogTitle, maxWidth = 'md', primaryButton, secondaryButton, handleFileChange, extension, ...rest} = props;
  const [open, setOpen] = React.useState(false);
  const [key, setKey] = useState(0);

  const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const reader = new window.FileReader();
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      const fileName = file.name;
      const ext = fileName.split('.').pop()?.toLowerCase();
      if (extension === ext) {
        reader.onload = (e) => {
          handleFileChange(e.target?.result as string);
          setOpen(true);
        };
        reader.readAsText(file);
      } else {
        toast.error('Тhe file is not in correct format!');
      }
    }
    // Force re-render of FilePicker to reset the file input
    setKey((prev) => prev + 1);
  };

  return (
    <React.Fragment>
      <FilePicker key={key} onFileChange={onFileChange} {...rest} />
      <DialogContextProvider>
        <CustomDialog
          maxWidth={maxWidth}
          primaryButton={primaryButton}
          secondaryButton={secondaryButton}
          dialogTitle={dialogTitle}
          open={open}
          resetDialog={() => setOpen(false)}
        >
          {children}
        </CustomDialog>
      </DialogContextProvider>
    </React.Fragment>
  );
};

type FilePickerDialogProps = Omit<FilePickerProps, 'onFileChange'> & {
  children: ReactNode;
  dialogTitle?: string;
  primaryButton?: JSX.Element;
  secondaryButton?: JSX.Element;
  maxWidth?: false | Breakpoint;
  extension: string;
  handleFileChange: (results: string) => void;
};

export default FilePickerDialog;
